import { gql } from '@apollo/client';

/** Floorplan query with sharing + ownership fields for collab. */
export const FloorplanWithSharingDocument = gql`
  query floorplanWithSharing($id: String!) {
    floorplan(id: $id) {
      id
      name
      json
      backdropImage
      backdropRatio
      backdropSize
      currency
      updatedAt
      isOwner
      user {
        id
        userName
        email
      }
      sharedWith {
        id
        userName
        email
      }
      editingBy {
        id
        userName
        email
      }
      editingExpiresAt
    }
  }
`;

/** Floorplans list including shared plans and ownership. */
export const FloorplansWithSharingDocument = gql`
  query floorplansWithSharing {
    floorplans {
      id
      name
      isOwner
      user {
        id
        userName
        email
      }
      sharedWith {
        id
        userName
        email
      }
    }
  }
`;

export const ShareFloorplanDocument = gql`
  mutation shareFloorplan($floorplanId: String!, $email: String!) {
    shareFloorplan(floorplanId: $floorplanId, email: $email) {
      id
      sharedWith {
        id
        userName
        email
      }
    }
  }
`;

export const UnshareFloorplanDocument = gql`
  mutation unshareFloorplan($floorplanId: String!, $userId: String!) {
    unshareFloorplan(floorplanId: $floorplanId, userId: $userId) {
      id
      sharedWith {
        id
        userName
        email
      }
    }
  }
`;

export const ClaimFloorplanEditorDocument = gql`
  mutation claimFloorplanEditor($floorplanId: String!, $force: Boolean) {
    claimFloorplanEditor(floorplanId: $floorplanId, force: $force) {
      isMine
      updatedAt
      editingExpiresAt
      editingBy {
        id
        userName
        email
      }
    }
  }
`;

export const ReleaseFloorplanEditorDocument = gql`
  mutation releaseFloorplanEditor($floorplanId: String!) {
    releaseFloorplanEditor(floorplanId: $floorplanId)
  }
`;

/** Instant lease/save notifications for shared floorplans. */
export const FloorplanCollabChangedDocument = gql`
  subscription floorplanCollabChanged($floorplanId: String!) {
    floorplanCollabChanged(floorplanId: $floorplanId) {
      floorplanId
      updatedAt
      editingBy {
        id
        userName
        email
      }
    }
  }
`;

/** Save with optimistic concurrency token. */
export const EditFloorplanWithVersionDocument = gql`
  mutation editFloorplanWithVersion(
    $id: ID!
    $name: String
    $json: String
    $image: Upload
    $currency: String
    $expectedUpdatedAt: DateTime
  ) {
    editFloorplan(
      input: {
        id: $id
        name: $name
        json: $json
        image: $image
        currency: $currency
        expectedUpdatedAt: $expectedUpdatedAt
      }
    ) {
      id
      name
      image
      thumbnail
      currency
      updatedAt
    }
  }
`;
